module.exports = __webpack_public_path__ + "img/logo.d88002a7.svg";